<template>
  <div
    class="ranges-tables-layout rtlay"
    :class="[
      { rtlay_flipped: flipped },
      { rtlay_single: (!showCenter || !hasCenter) && !showRight },
      { 'rtlay_no-center': !showCenter || !hasCenter },
    ]"
    :style="columnStyle"
  >
    <div
      v-if="hasLeft"
      v-show="showLeft"
      class="rtlay_left std_cont_left std_cont"
      data-tst="rtlay_left"
    >
      <slot name="left" />
    </div>
    <div
      v-if="hasCenter"
      v-show="showCenter"
      class="rtlay_center std_cont"
    >
      <slot name="center" />
    </div>
    <div
      v-if="hasRight"
      v-show="showRight"
      class="rtlay_right std_cont"
      data-tst="rtlay_right"
    >
      <slot name="right" />
    </div>

    <!-- <div class="rtlay_after" v-show="showRight"> -->
    <slot name="after" />
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'RtLayout',
  props: {
    flipped: Boolean,
    hasLeft: { type: Boolean, default: true },
    hasRight: { type: Boolean, default: true },
    hasCenter: { type: Boolean, default: true },
    showLeft: { type: Boolean, default: true },
    showCenter: { type: Boolean, default: true },
    showRight: { type: Boolean, default: true },
  },
  computed: {
    columnStyle() {
      const res = `--grid-columns: ${this.showLeft ? '1fr' : ''} ${this.showCenter ? 'auto' : ''} ${
        this.showRight ? '1fr' : ''
      }`
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.rtlay {
  flex: 1;
  position: relative;
  max-width: 100vw;
  max-height: 100%;

  --grid-gap: 0;
  --grid-columns: 1fr auto 1fr;
  --clr-rtlayout-back: transparent;
  --order-left: 1;
  --order-center: 2;
  --order-right: 3;
  --padding-center: 0;
  // --padding-center: 0 0.5rem;

  display: grid;
  grid-gap: var(--grid-gap);
  background: var(--clr-rtlayout-back);
  grid-template-columns: var(--grid-columns);

  &_flipped {
    --order-left: 3;
    --order-center: 2;
    --order-right: 1;
  }
  &_left,
  &_center,
  &_right {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
  }

  &_left {
    z-index: 2;
    flex: 1;
    order: var(--order-left);
  }
  &_center {
    z-index: 3;
    order: var(--order-center);
    padding: var(--padding-center);
  }
  &_right {
    z-index: 2;
    flex: 1;
    order: var(--order-right);
  }
}

@media (max-width: 1023px) and (orientation: portrait) {
  .rtlay {
    overflow-x: hidden;
    overflow-y: auto;

    --grid-gap: 0.5rem;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: calc(clamp(12rem, 28rem, 50vw) + 0.5rem) auto;
    grid-template-areas:
      'a b'
      'c c';
    &.rtlay_no-center {
      grid-template-areas: 'a b';
    }
    .rtlay {
      &_left {
        grid-area: a;
        // max-height: 50vw;
      }
      &_center {
        grid-area: c;
      }
      &_right {
        grid-area: b;
        // max-height: 50vw;
      }
    }
  }
  .rtlay_flipped {
    grid-template-areas:
      'b a'
      'c c';
  }
  .rtlay_single {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    grid-template-areas:
      'a a'
      'a a';
  }
  .rtlay_no-center {
    // border: 1px solid red;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    grid-template-areas:
      'a b'
      'a b';
    &.rtlay_flipped {
      grid-template-areas:
        'b a'
        'b a';
    }
    &.rtlay_single {
      grid-template-areas:
        'a a'
        'a a';
    }
  }
}

@media screen and (orientation: portrait) {
  .small_screen_layout {
    --hspots-grid-column: 1;
    --hspots-grid-row: 1;
    --main-grid-column: 1;
    --main-grid-row: 2 / 3;
    --aside-grid-column: 1;
    --aside-grid-row: 3 / 4;
    .laytsttd_content {
      grid-template-columns: 1fr;
      grid-template-rows: auto 1fr auto;
    }
  }
}
</style>
